
import './App.css';
import { Navigate, Route, HashRouter as Router, Routes, useLocation, useNavigate } from "react-router-dom";
import EdisPaymentComponent from "./components/payments/EdisPaymentComponent.tsx"
import EdisPaymentProcessingComponent from "./components/payments/EdisPaymentProcessingComponent.tsx"
import PaymentLink from './components/payments/PaymentLink.tsx';
import EdisPaymentConfirmationComponent from './components/payments/EdisPaymentConfirmationComponent.tsx';
import TokenExpiredPageComponent from './components/payments/TokenExpiredPageComponent.tsx';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // PrimeReact Theme
import 'primereact/resources/primereact.min.css';
const App: React.FC = () => {
  return (
       <div>
      <div className="d-flex flex-column min-vh-100">
        <div className="flex-grow-1">
          <Routes>
            
           <Route path="/" element={<EdisPaymentComponent />} />
            <Route path="/paymentprocessing" element={<EdisPaymentProcessingComponent />} />
            <Route path="/paymentresponseconfirmation" element={<EdisPaymentConfirmationComponent />} />
            <Route path="/paymenttokenexpired" element={<TokenExpiredPageComponent />} />
           </Routes>
           </div>
      </div>
      </div>
  );
}

export default App;
